import axios from "axios";
import qs from 'qs';
import _ from "underscore";
import {doesTokenExists, isSessionValid, isTokenValid} from "../utils/sessionUtils";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;//backend url
const appBaseUrl = process.env.REACT_APP_BASE_URL;// actual front end url
const env = process.env.REACT_APP_ENV;
//todo : add environment variable file
const axiosInstance = axios.create({
    baseURL: (env === 'LOCAL') ? appBaseUrl : apiBaseURL,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    paramsSerializer: params => {
        return qs.stringify(params, {indices: false})
    }
});

// todo : add JWT from local storage
// todo : add csrf from local storage
axiosInstance.interceptors.request.use((axiosRequestConfig) => {
    //axiosRequestConfig.headers =
    if (sessionStorage.getItem('fmap-session-token')) {
        axiosRequestConfig.headers = {
            ...axiosRequestConfig.headers,
            'Authorization': `Bearer ${sessionStorage.getItem('fmap-session-token')}`,
            'Accept': 'application/json'
        }
    }
    axiosRequestConfig.withCredentials = true;
    return axiosRequestConfig;
}, error => {
    return Promise.reject(error)
});

axiosInstance.interceptors.response.use(data => {
    return data?.data;
}, error => {
        if (doesTokenExists() && !(error?.config?.url.includes('unauth') ||error?.config?.url.includes('agentRegistration')) && !isTokenValid()) {
            return window.location.replace(process.env.REACT_APP_BASE_URL + 'logout/3');
        }
        return Promise.reject(error);
        // let errorMsg = error?.data?.messages;
        // if (_.isNullOrUndefined(errorMsg)) {
        //     return Promise.reject({messages : (errorMsg instanceof Array) ? errorMsg : [errorMsg]});
        // } else {
        //     return Promise.reject({messages : "An error occurred. Please try again later."});
        // }
});

export default axiosInstance;
